<!--footer section -->
<footer [class]="class">
	<div class="light-layout" *ngIf="newsletter">
		<div class="container">
			<section class="small-section border-section border-top-0">
				<div class="row">
					<div class="col-lg-6">
						<div class="subscribe">
							<div>
								<h4>NON PERDERTI NESSUNA NOVITÀ!</h4>
								<p>Iscriviti alla nostra Newsletter e riceverai subito un codice sconto del 10%.</p>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<form *ngIf="!showThanksForNewsletter" class="form-inline subscribe-form" action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda" target="_blank" method="post">
							<div class="form-group mx-sm-3">
								<input type="email" [(ngModel)]="email" name="EMAIL" id="mce-EMAIL" class="form-control" placeholder="Inserisci la tua mail">
							</div>
							<button (click)="onAddNewsletterContact()" type="submit" class="btn btn-solid">ISCRIVITI</button>
						</form>
						<div *ngIf="showThanksForNewsletter">
							<label>Grazie per esserti iscritto alla nostra newsletter</label>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
	<section class="section-b-space light-layout">
		<div class="container">
			<div class="row footer-theme partition-f">
				<div class="col-lg-4 col-md-6">
					<div class="footer-title footer-mobile-title">
						<h4>about</h4>
					</div>
					<div class="footer-contant">
						<div class="footer-logo">
							<img (click)="onGoToHome()" class="footer-logo-size" [src]="themeLogo" alt="logo">
						</div>
						<div class="footer-social">
                            <ul>
                                <li>
                                    <a target="_blank" href="https://www.facebook.com/profile.php?id=100085959177605"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.instagram.com/outgravitywear/"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li>
                            </ul>
                        </div>
					</div>
				</div>
				<div class="col">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>INFORMAZIONI UTILI</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li><a [routerLink]="['/pages/resi-spedizione']" fragment="spedizioni">Spedizioni</a></li>
                                <li><a [routerLink]="['/pages/resi-spedizione']" fragment="resi">Politica Resi</a></li>
								<li><a [routerLink]="['/pages/resi-spedizione']" fragment="reso">Effettua un reso</a></li>
                                <li>
									<a target="_blank" href="https://www.iubenda.com/termini-e-condizioni/91785635" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " title="Termini e Condizioni ">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
								</li>
                                <li>
									<a target="_blank" href="https://www.iubenda.com/privacy-policy/91785635" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
								</li>
                            </ul>
                        </div>
					</div>
				</div>
				<div class="col">
					<div class="sub-title">
						<div class="footer-title footer-contact-mobile">
						    <h4>CONTATTI</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><a target="_blank" href="mailto:info@out-wear.com">Contattaci</a></li>
						    </ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<div class="sub-footer">
		<div class="container">
			<div class="row">
                <div class="col text-center" style="margin-top: 1%;">
                    2023, OUT di Soresina Riccardo - P. Iva: 03092570302 - 33100 Udine (UD), Italia.
                </div>
            </div>
			<div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="footer-end">
                    <p style="font-size: 70%;">Website developed by Gabriele Francescutto</p>
                  </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a><img src="web/assets/images/icon/visa.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="web/assets/images/icon/mastercard.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="web/assets/images/icon/paypal.png" alt=""></a>
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
		</div>
	</div>
</footer>
<!--footer section end -->